import * as React from "react";
import { useState as useComfortState } from "../../../../context/reports/comfort";
import { useActions as useComfortActions } from "../../../../context/reports/comfort/useActions";

interface UsePortfolioEffects {
  appReady: boolean;
  sites: string[];
}

export function usePortfolioEffects({ appReady, sites }: UsePortfolioEffects) {
  const state = useComfortState();
  const { getPortfolio } = useComfortActions();
  const didMountRef = React.useRef(false);

  const { current, compare, timeFrameOption, compareToOption } = state;

  // * If portfolio data has not yet been loaded, request it
  React.useEffect(() => {
    if (appReady && !state.portfolioLoading && !state.portfolioLoaded) {
      didMountRef.current = true;
      void getPortfolio({
        siteIds: sites,
        current,
        compare,
      });
    }
  }, [appReady]);

  // * If sites list changes AFTER initial mount, refresh portfolio data
  React.useEffect(() => {
    // * Avoid repeat requests if portfolio data has already been requested/loaded
    // * when navigating back to the zones/portfolio views after initial load
    if (sites.join("") === state.activeSitesHash) return;

    if (appReady && !state.portfolioLoading && state.portfolioLoaded) {
      void getPortfolio({
        siteIds: sites,
        current,
        compare,
      });
    }
  }, [sites]);

  // * If time frame changes AFTER initial mount, refresh portfolio data
  React.useEffect(() => {
    if (
      appReady &&
      !state.portfolioLoading &&
      state.portfolioLoaded &&
      didMountRef.current
    ) {
      void getPortfolio({
        siteIds: sites,
        current,
        compare,
      });
    }

    didMountRef.current = true;
  }, [timeFrameOption, compareToOption]);
}
